import { reactive, ref } from 'vue';

export function useCheckoutValidation() {
  const isProcessing = ref(false); // <-- Adicione esta linha

  const form = reactive({
    name: '',
    cardNumber: '',
    expiry: '',
    cvv: ''
  });

  const errors = reactive({
    name: '',
    cardNumber: '',
    expiry: '',
    cvv: ''
  });

  const validateForm = () => {
    let isValid = true;
    // ... (suas lógicas de validação que já fizemos)
    if (form.name.length < 3) {
      errors.name = "Nome muito curto";
      isValid = false;
    } else {
      errors.name = "";
    }
    return isValid;
  };

  // Exportamos o isProcessing para o componente enxergá-lo
  return {
    form,
    errors,
    isProcessing, 
    validateForm
  };
}